import { IAction } from '../models/action';
import { REQUEST_WALL_SUCCESS } from '../handlers.actions';

const initWallsStore: any = () => ([]);

/** WALLS REDUCER */
export const wallReducer = (state = initWallsStore(), action: IAction) => {
    switch (action.type) {        
         case REQUEST_WALL_SUCCESS:
              return {...action.payload}
         default:
              return state;
    }
};